import {Component, OnInit} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {CustomersService} from '../../services/customers.service';
import {FormControlTypeEnum} from '../../models/FormControlTypeEnum';
import {GetCustomerCategoryResponseDto} from '../../models/GetCustomerCategoryResponseDto';
import {GetTriggerCategoryResponseDto} from '../../models/GetTriggerCategoryResponseDto';
import {TranslateService} from '@ngx-translate/core';
import {ToastsManager} from 'ng2-toastr';

@Component({
    selector: 'app-import-customers-modal',
    templateUrl: './import-customers-modal.component.html',
    styleUrls: ['./import-customers-modal.component.css']
})
export class ImportCustomersModalComponent implements OnInit {
    form: FormGroup;
    modalRef: NgbModalRef;
    errorMessage: string;
    isLoading = false;
    FormControlTypeEnum = FormControlTypeEnum;
    selectedCustomerCategory: GetCustomerCategoryResponseDto;
    selectedTriggerCategory: GetTriggerCategoryResponseDto;

    constructor(private modalService: NgbModal,
                private fb: FormBuilder,
                private customersService: CustomersService,
                private translateService: TranslateService,
                private toastr: ToastsManager) {
    }

    ngOnInit() {
        this.form = this.fb.group({
            'importArea': ['', [Validators.required]]
        });
    }

    openImportModal(modalContent) {
        this.modalRef = this.modalService.open(modalContent);
    }

    onCustomerCategoryChanged(customerCategory: GetCustomerCategoryResponseDto) {
        this.selectedCustomerCategory = customerCategory;
    }

    onTriggerCategoryChanged(triggerCategory: GetTriggerCategoryResponseDto) {
        this.selectedTriggerCategory = triggerCategory;
    }

    onSubmit($event): void {
        this.errorMessage = '';
        // Set all the fields dirty
        for (const control in this.form.controls) {
            const field = this.form.controls[control];
            (field as FormControl).markAsDirty();
            field.updateValueAndValidity();
        }

        if (!this.form.valid) {
            console.log('not valid');
            return;
        }

        this.isLoading = true;
        try {
            this.customersService.importCustomers(
                this.form.value['importArea'],
                this.selectedCustomerCategory.id,
                this.selectedTriggerCategory.id).subscribe(
                response => {
                    this.form.reset();
                    this.isLoading = false;
                    this.translateService.get('importCustomersSuccessMessage').subscribe(result => {
                        this.toastr.success(result);
                    });
                },
                error => {
                    this.translateService.get('genericErrorMessage').subscribe(result => {
                        this.toastr.error(result);
                    });
                    this.isLoading = false;
                    console.log(error);
                }
            );
        } catch (SyntaxError) {
            this.translateService.get('csvSyntaxErrorMessage').subscribe(result => {
                this.errorMessage = result;
            });
            this.isLoading = false;
        }
    }

}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/import-customers-modal/import-customers-modal.component.ts